import { faker } from '@faker-js/faker';

import type { AdminUser, DepartmentDetails } from '~/api/types';
import { USER_ROLES } from '~/features/auth/roles';

const roles = [
  USER_ROLES.HcpAdmin,
  USER_ROLES.NonHcpAdmin,
  USER_ROLES.HcpUser,
  USER_ROLES.AbbottUser,
  USER_ROLES.AdminAbbott,
] as const;

export const adminUserFactory = ({
  departmentDetails,
  overrides,
}: {
  departmentDetails: DepartmentDetails[];
  overrides?: Partial<AdminUser>;
}): AdminUser => {
  const role = faker.helpers.arrayElement(roles);

  const mainDepartment = faker.helpers.arrayElement(departmentDetails);

  const departments = faker.helpers.arrayElements(departmentDetails, 5);

  const email = faker.internet.email(
    role === USER_ROLES.AbbottUser || role === USER_ROLES.AdminAbbott
      ? { provider: 'abbott.com' }
      : undefined,
  );

  return {
    id: faker.string.uuid(),
    lastName: faker.person.lastName(),
    firstName: faker.person.firstName(),
    email,
    phone: faker.phone.number({ style: 'international' }),
    departments,
    mainDepartment,
    // allDepartmentsAccess: role === USER_ROLES.HcpAdmin,
    role,
    archivedAt: faker.datatype.boolean()
      ? faker.date.past().toISOString()
      : undefined,
    lastLogin: faker.datatype.boolean()
      ? faker.date.past().toISOString()
      : undefined,
    ...overrides,
  } satisfies AdminUser;
};
